import React, { useState } from "react";
import { format } from "date-fns";
import styles from "./Card.module.css";
import { FaTicketAlt, FaHistory, FaUserTie, FaCommentAlt, FaClock } from 'react-icons/fa';

function Card({ ticket, allticketced }) {
  const [showModal, setShowModal] = useState(false);
  const [historial, setHistorial] = useState([]);

  if (!ticket) return null;

  const getEstadoDescripcion = (estadoId) => {
    switch (estadoId) {
      case 1: return "Creado";
      case 2: return "Asignado";
      case 4: return "En proceso";
      case 5: return "Cerrado";
      case 6: return "Cancelado";
      default: return estadoId || "N/A";
    }
  };

  const getStatusClass = (estadoId) => {
    if (estadoId === 5) return styles.cerrado;
    if (estadoId === 6) return styles.cancelado;
    return "";
  };

  const formatFecha = (fecha) => {
    if (!fecha) return "N/A";
    try {
      return format(new Date(fecha), "dd/MM/yyyy HH:mm");
    } catch (e) {
      return "N/A";
    }
  };

  const handleMostrarDetalles = () => {
    const detalles = allticketced.filter(
      (t) => t.TicketId === ticket.TicketId && t.isMto === ticket.isMto
    );
    setHistorial(detalles);
    setShowModal(true);
  };

  return (
    <>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <div className={styles.ticketBadge}>
              <FaTicketAlt />
              <span>#{ticket.TicketId}</span>
            </div>
            <span className={`${styles.areaBadge} ${ticket.isMto ? styles.mtoBadge : styles.tiBadge}`}>
              {ticket.area}
            </span>
          </div>
          <div className={`${styles.statusBadge} ${getStatusClass(ticket.EstadoId)}`}>
            {getEstadoDescripcion(ticket.EstadoId)}
          </div>
        </div>

        <div className={styles.cardBody}>
          <div className={styles.infoRow}>
            <div className={styles.iconLabel}>
              <FaClock />
              <span className={styles.label}>Última actualización:</span>
            </div>
            <span className={styles.value}>{formatFecha(ticket.fecha)}</span>
          </div>

          <div className={styles.infoRow}>
            <div className={styles.iconLabel}>
              <FaUserTie />
              <span className={styles.label}>Técnico:</span>
            </div>
            <span className={styles.value}>{ticket.UsuarioId || "Sin asignar"}</span>
          </div>

          <div className={styles.observacionSection}>
            <div className={styles.iconLabel} style={{ marginBottom: '4px' }}>
              <FaCommentAlt />
              <span className={styles.label}>Observación:</span>
            </div>
            <p className={styles.observacionText}>{ticket.observacion}</p>
          </div>
        </div>

        <button className={styles.detalleBtn} onClick={handleMostrarDetalles}>
          Ver Historial Completo
        </button>
      </div>

      {/* MODAL PRO */}
      {showModal && (
        <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3><FaHistory style={{ marginRight: '10px' }} /> Historial {ticket.area} #{ticket.TicketId}</h3>
              <button
                onClick={() => setShowModal(false)}
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b' }}
              >&times;</button>
            </div>

            <div className={styles.modalBody}>
              <div className={styles.historialContainer}>
                {historial
                  .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
                  .map((item, idx) => (
                    <div key={item.id || idx} className={styles.historialCard}>
                      <div className={styles.histHeader}>
                        <span className={`${styles.histEstado} ${getStatusClass(item.EstadoId)}`}>
                          {getEstadoDescripcion(item.EstadoId)}
                        </span>
                        <span className={styles.histFecha}>
                          {formatFecha(item.fecha)}
                        </span>
                      </div>
                      <p className={styles.histObs}>{item.observacion}</p>
                    </div>
                  ))}
              </div>
            </div>

            <div className={styles.modalFooter}>
              <button
                className={styles.cerrarBtn}
                onClick={() => setShowModal(false)}
              >
                Cerrar Historial
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Card;
